//새 버전 배포 확인 → 메뉴 이동 때 새 화면으로 다시 불러오기
//- 탭을 오래 열어 둔 사용자(엣지 탭 복원·절전 탭 등)가 예전 화면에 머무는 문제
//- 지금 실행 중인 app.[해시].js 와 서버 index.html 의 app.[해시].js 를 비교 (배포마다 해시가 바뀜)
//- 주기적으로 확인하지 않고, 메뉴를 옮길 때만 확인 (연달아 옮길 땐 30초에 한 번)
//- 다시 불러올 때 주소에 ?_pv=버전 을 붙임: 기관 프록시·보안 장비가 예전 index.html 을 캐시해 둬도 새 주소라 서버에서 새로 받음
//  (불러온 뒤 주소에서는 바로 지움, sessionStorage 가 막힌 브라우저에서도 이 값으로 무한 새로고침 방지)
import { buildVersion } from '@/utils/clientEnv';

const CHECK_GAP = 30 * 1000;
const TIMEOUT = 2000;   //서버가 늦으면 확인 없이 그냥 이동
const RELOADED_KEY = 'pasm_reloaded_for';   //같은 버전으로 두 번 다시 불러오지 않게 (sessionStorage)

const RELOAD_PARAM = '_pv';

let lastCheck = 0;

//다시 불러와서 들어온 경우: 어느 버전 때문에 왔는지 기억하고 주소에서는 지움 (라우터가 주소를 읽기 전에)
const ARRIVED_FOR = (() => {
    try {
        const url = new URL(window.location.href);
        const v = url.searchParams.get(RELOAD_PARAM);
        if (v == null) return '';
        url.searchParams.delete(RELOAD_PARAM);
        window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
        return v;
    } catch (e) { return ''; }
})();

function getSession(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
function setSession(k, v) { try { sessionStorage.setItem(k, v); } catch (e) { /* noop */ } }

//서버의 최신 버전 (index.html 의 app.[해시].js). 실패하면 ''
async function latestVersion() {
    const ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    const timer = setTimeout(() => ctrl && ctrl.abort(), TIMEOUT);
    try {
        //cache: 'reload' → 브라우저 캐시를 건너뛰고 받고, 받은 것으로 캐시도 갱신
        const res = await fetch('/?_v=' + Date.now(), { cache: 'reload', credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined });
        if (!res.ok) return '';
        const m = (await res.text()).match(/\/js\/app\.([0-9a-f]+)\.js/);
        return m ? m[1] : '';
    } catch (e) {
        return '';
    } finally {
        clearTimeout(timer);
    }
}

//새 버전이 있으면 그 버전 해시, 없으면 ''
export async function newVersionAvailable(force) {
    const current = buildVersion();
    if (current == 'dev') return '';   //로컬 개발 서버
    const now = Date.now();
    if (!force && now - lastCheck < CHECK_GAP) return '';
    lastCheck = now;
    const latest = await latestVersion();
    if (!latest || latest == current) return '';
    if (getSession(RELOADED_KEY) == latest || ARRIVED_FOR == latest) return '';   //이미 한 번 다시 불러왔는데도 그대로면 더 하지 않음
    return latest;
}

//새 화면으로 다시 불러오기 (path 로 이동, 없으면 지금 화면)
export function reloadTo(version, path) {
    setSession(RELOADED_KEY, version);
    try {
        const url = new URL(path || window.location.href, window.location.origin);
        url.searchParams.set(RELOAD_PARAM, version);
        window.location.assign(url.pathname + url.search + url.hash);
    } catch (e) {
        window.location.reload();
    }
}

//배포 뒤 예전 화면에서 메뉴를 누르면 지워진 예전 파일(chunk)을 못 받아 오류 → 한 번만 다시 불러오기
export function isChunkLoadError(err) {
    const msg = (err && (err.message || String(err))) || '';
    return /Loading (CSS )?chunk [\w-]+ failed|ChunkLoadError|Failed to fetch dynamically imported module/i.test(msg);
}
export function reloadForChunkError(path) {
    const key = 'chunk:' + buildVersion();   //지금 화면 버전마다 한 번
    if (getSession(RELOADED_KEY) == key || ARRIVED_FOR == key) return false;
    reloadTo(key, path);
    return true;
}
